<template>
  <div class="uk-container uk-margin-large-bottom">
    <p>
      <a :href="this.JSparams.buy_page">{{i18n["trial-subline-text"]}}</a>
    </p>
    <div uk-grid class="uk-grid-collapse uk-grid-divider uk-child-width-expand@s">
      <div class="uk-width-1-2@m">
        <div class="form-wrapper" v-if="status !== 'done'" id="form-wrapper">
          <div v-if="status !== 'done'">
            <ul class="uk-list">
              <li id="aboutyou" v-show="step === 1">
                <ValidationObserver ref="step1" v-slot="{ invalid, errors }" tag="form" class="uk-form-stacked" novalidate @submit.stop.prevent="toStep(2)" :class="{disabled: status === 'saving'}">
                  <ValidationProvider name="email" rules="required" v-slot="{ failed, passed, errors, classes }" tag="div" class="uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                    <div>
                      <label class="uk-form-label" for="email">{{i18n["step3-email"]}} *</label>
                      <div class="uk-form-controls uk-position-relative">
                        <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="passed && checkField !== 'email'"></i>
                        <i class="fas fa-circle-notch fa-spin uk-form-icon uk-form-icon-flip uk-hidden@m" v-show="checkField === 'email'"></i>
                        <input class="uk-input" id="email" v-model="customer.data.email" type="email" :class="classes">
                      </div>
                    </div>

                    <div class="field-check uk-width-1-4@m">
                      <label class="uk-visible@s uk-form-label">&nbsp;</label>
                      <span class="uk-form-danger" v-if="failed && errors[0] !== 'duplicate_account' && checkField !== 'email'"><i class="fas fa-times"></i> {{i18n["step3-emailerror"]}}</span>
                      <span class="uk-form-danger" v-if="failed && errors[0] === 'duplicate_account' && checkField !== 'email'"><i class="fas fa-times"></i> {{i18n["step3-emailerror-duplicate"]}}</span>
                      <span class="uk-form-success uk-visible@m" v-if="passed && checkField !== 'email'"><i class="fas fa-check"></i></span>
                      <i class="fas fa-circle-notch fa-spin uk-visible@m" v-show="checkField === 'email'"></i>
                    </div>
                  </ValidationProvider>

                  <ValidationProvider name="emailRepeat" rules="required:@email" v-slot="{ failed, passed, errors, classes }" tag="div" class="uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                    <div>
                      <label class="uk-form-label" for="emailRepeat">{{i18n["step3-email-repeat"]}} *</label>
                      <div class="uk-form-controls uk-position-relative">
                        <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="passed"></i>
                        <input class="uk-input" id="emailJhbfe" @paste.prevent v-model="customer.data.emailRepeat" type="email" :class="classes">
                      </div>
                    </div>

                    <div class="field-check uk-width-1-4@m">
                      <label class="uk-visible@s uk-form-label">&nbsp;</label>
                      <span class="uk-form-danger" v-if="failed && errors[0] !== 'duplicate_account' && checkField !== 'email'"><i class="fas fa-times"></i> {{i18n["step3-emailerror-repeat"]}}</span>
                      <span class="uk-form-success uk-visible@m" v-if="passed && checkField !== 'email'"><i class="fas fa-check"></i></span>
                    </div>
                  </ValidationProvider>

                  <ValidationProvider name="firstName" rules="required" v-slot="{ failed, passed, errors, classes }" tag="div" class="uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                    <div>
                      <label class="uk-form-label" for="firstName">{{i18n["step2-firstname"]}} *</label>
                      <div class="uk-form-controls uk-position-relative">
                        <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="passed"></i>
                        <input class="uk-input" v-model="customer.data.firstName" type="text" :class="classes">
                      </div>
                    </div>

                    <div class="field-check uk-width-1-4@m">
                      <label class="uk-form-label uk-visible@m">&nbsp;</label>
                      <span class="uk-form-danger" v-if="failed"><i class="fas fa-times"></i> {{i18n["step2-firstnameerror"]}}</span>
                      <span class="uk-form-success uk-visible@m" v-show="passed"><i class="fas fa-check"></i></span>
                    </div>
                  </ValidationProvider>

                  <ValidationProvider name="lastName" rules="required" v-slot="{ failed, passed, errors, classes }" tag="div" class="uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                    <div>
                      <label class="uk-form-label" for="lastName">{{i18n["step2-lastname"]}} *</label>
                      <div class="uk-form-controls uk-position-relative">
                        <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="passed"></i>
                        <input class="uk-input" v-model="customer.data.lastName" type="text" :class="classes">
                      </div>
                    </div>

                    <div class="field-check uk-width-1-4@m">
                      <label class="uk-form-label uk-visible@m">&nbsp;</label>
                      <span class="uk-form-danger" v-if="failed"><i class="fas fa-times"></i> <span>{{ errors[0] }}</span> {{i18n["step2-lastnameerror"]}}</span>
                      <span class="uk-form-success uk-visible@m" v-show="passed"><i class="fas fa-check"></i></span>
                    </div>
                  </ValidationProvider>

                  <ValidationProvider name="country" rules="required" v-slot="{ failed, passed, errors, classes }" tag="div"  class="uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                    <div>
                      <label class="uk-form-label" for="country">{{i18n["step2-country"]}} *</label>
                      <div class="uk-form-controls uk-position-relative">
                        <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="passed"></i>
                        <select class="uk-select" id="country" v-model="customer.data.country" :class="classes">
                          <option v-for="(country, index) in countries.getNames(i18n.language)" :key="index" :value="index">{{country}}</option>
                        </select>
                      </div>
                    </div>

                    <div class="field-check uk-width-1-4@m">
                      <label class="uk-form-label uk-visible@m">&nbsp;</label>
                      <span class="uk-form-danger" v-if="failed"><i class="fas fa-times"></i> {{i18n["step2-countryerror"]}}</span>
                      <span class="uk-form-success uk-visible@m" v-show="passed"><i class="fas fa-check"></i></span>
                    </div>
                  </ValidationProvider>

                  <div v-if="duplicateAccount" class="uk-alert-danger" uk-alert v-html="i18n.error_duplicate_account">
                  </div>

                  <div v-if="status === 'error'" class="uk-alert-danger" uk-alert v-html="i18n.error_general">
                  </div>

                  <div class="uk-flex uk-flex-right uk-margin-top" v-if="status !== 'error'">
                    <button class="uk-button uk-button-primary" type="submit" :disabled="invalid || status === 'saving' || checkField !== ''">{{i18n["button-next"]}} <i class="fas fa-arrow-right"></i></button>
                  </div>
                </ValidationObserver>
              </li>

              <li class="payment uk-position-relative" v-show="step === 2">
                <div v-if="customer.data.email !== ''" class="uk-text-small">
                  {{i18n["trial-subline_setup"]}} <span class="uk-text-bold">{{customer.data.email}}</span>
                </div>
                <h2>2. {{i18n["step4-headline"]}} <span class="uk-text-small uk-text-bold">
                  - {{i18n["trial-nochargenow"]}}
                </span> <i class="fas fa-lock fa-xs"></i></h2>

                <div class="uk-margin">
                    <div class="uk-form-controls">
                        <label class="uk-margin-right uk-margin-bottom uk-display-block uk-display-inline@s">
                          <img class="uk-margin-small-right ccardicon" :src="wpParams.template_path + '/assets/img/vue/cc-visa.png'" />
                          <img class="uk-margin-small-right ccardicon" :src="wpParams.template_path + '/assets/img/vue/cc-mastercard.png'" />
                          <img class="uk-margin-small-right ccardicon" :src="wpParams.template_path + '/assets/img/vue/cc-amex.png'" />
                          <img class="uk-margin-small-right ccardicon" :src="wpParams.template_path + '/assets/img/vue/cc-discover.png'" />
                          <img class="uk-margin-small-right ccardicon" :src="wpParams.template_path + '/assets/img/vue/cc-diners.png'" />
                          <img class="uk-margin-small-right ccardicon" :src="wpParams.template_path + '/assets/img/vue/cc-jcb.png'" />
                        </label>
                    </div>
                </div>

                <ValidationObserver ref="step2" v-slot="{ invalid, errors, handleSubmit }" tag="div">
                  <form class="uk-form-stacked" novalidate @submit.prevent="handleSubmit(signup)">
                    <ValidationProvider name="ccholder" rules="required" v-slot="{ failed, dirty, passed, classes }" tag="div" class="uk-child-width-expand@s" uk-grid>
                      <div>
                        <label class="uk-form-label" for="email">{{i18n["step4-ccholder"]}} *</label>
                        <div class="uk-form-controls uk-position-relative">
                          <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="dirty && passed"></i>
                          <input class="uk-input" v-model="customer.payment.ccard.cardHolder" type="text" :class="classes">
                        </div>
                      </div>

                      <div class="field-check uk-width-1-4@m">
                        <label class="uk-form-label uk-visible@m ">&nbsp;</label>
                        <span class="uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> {{i18n["step4-ccholdererror"]}}</span>
                        <span class="uk-form-success uk-visible@m" v-show="dirty && passed"><i class="fas fa-check"></i></span>
                      </div>
                    </ValidationProvider>

                    <ValidationProvider name="ccnumber" rules="required|credit_card" v-slot="{ failed, dirty, passed, classes }" tag="div" class="uk-child-width-expand@s" uk-grid>
                      <div>
                        <label class="uk-form-label" for="ccnumber">{{i18n["step4-ccnumber"]}} *</label>
                        <div class="uk-form-controls uk-position-relative">
                          <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="dirty && passed"></i>
                          <input class="uk-input" id="ccnumber" v-model="customer.payment.ccard.cardNumber" type="text" :class="classes">
                          <div class="uk-text-small" v-if="passed">{{customer.payment.cardType}}</div>
                        </div>
                      </div>

                      <div class="field-check uk-width-1-4@m">
                        <label class="uk-form-label uk-visible@m ">&nbsp;</label>
                        <span class="uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> {{i18n["step4-ccnumbererror"]}}</span>
                        <span class="uk-form-success uk-visible@m" v-show="dirty && passed"><i class="fas fa-check"></i></span>
                      </div>
                    </ValidationProvider>

                    <ValidationProvider name="cvc" rules="max:4|min:3" v-slot="{ failed, dirty, passed, classes }" tag="div" class="uk-child-width-expand@s" uk-grid>
                      <div>
                        <label class="uk-form-label" for="cvc">{{i18n["step4-ccsecurity"]}} *</label>
                        <div class="uk-form-controls uk-position-relative">
                          <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="dirty && passed"></i>
                          <input maxlength="4" class="uk-input" name="cvc" v-model="customer.payment.ccard.cvc" type="text" :class="classes">
                        </div>
                      </div>

                      <div class="field-check uk-width-1-4@m">
                        <label class="uk-form-label uk-visible@m ">&nbsp;</label>
                        <span class="uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> {{i18n["step4-ccsecurityerror"]}}</span>
                        <span class="uk-form-success uk-visible@m" v-show="dirty && passed"><i class="fas fa-check"></i></span>
                      </div>
                    </ValidationProvider>

                    <div class="uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                      <div>
                        <label class="uk-form-label" for="ccExpiryYear">{{i18n["step4-ccexpires"]}}</label>
                        <div uk-grid>
                          <ValidationProvider vid="ccExpiryYear" name="ccExpiryYear" rules="required" v-slot="{ dirty, passed, classes }" tag="div" class="uk-form-controls uk-position-relative uk-width-1-2">
                            <div class="uk-form-controls uk-position-relative">
                              <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="passed"></i>
                              <select key="expyear" class="uk-select" id="ccExpiryYear" v-model="customer.payment.ccard.expiryYear" :class="classes">
                                <option v-for="year in ccyears" :value="year" :key="year">{{year}}</option>
                              </select>
                            </div>
                          </ValidationProvider>

                          <ValidationProvider vid="ccExpiryMonth" name="ccExpiryMonth" rules="required" v-slot="{ dirty, passed, classes }" tag="div" class="uk-form-controls uk-width-1-2">
                            <div class="uk-form-controls uk-position-relative">
                              <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="passed"></i>
                              <select class="uk-select" name="ccexpiryMonth" v-model="customer.payment.ccard.expiryMonth" :class="classes">
                                <option v-for="month in ccmonths" :value="month" :key="month">{{month}}</option>
                              </select>
                            </div>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="field-check uk-width-1-4@m">
                        <label class="uk-form-label uk-visible@m">&nbsp;</label>
                        <span class="uk-form-danger" v-if="(errors.ccExpiryYear && errors.ccExpiryYear.length > 0) || (errors.ccExpiryMonth && errors.ccExpiryMonth.length > 0)"><i class="fas fa-times"></i> {{i18n["step4-ccexpireserror"]}}</span>
                        <span class="uk-form-success uk-visible@m" v-show="errors.ccExpiryYear && errors.ccExpiryYear.length === 0 && customer.payment.ccard.expiryYear > 0 && errors.ccExpiryMonth && errors.ccExpiryMonth.length === 0 && customer.payment.ccard.expiryMonth > 0"><i class="fas fa-check"></i></span>
                      </div>
                    </div>

                    <ValidationProvider name="cccountry" rules="required" v-slot="{ failed, dirty, passed, errors, classes }" tag="div"  class="uk-child-width-expand@s uk-flex uk-grid-small" uk-grid>
                      <div>
                        <label class="uk-form-label" for="cccountry">{{i18n["step4-cccountry"]}} *</label>
                        <div class="uk-form-controls uk-position-relative">
                          <i class="fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success" v-show="passed"></i>
                          <select class="uk-select" id="cccountry" v-model="customer.payment.ccard.country" :class="classes">
                            <option v-for="(country, index) in countries.getNames(i18n.language)" :key="index" :value="index">{{country}}</option>
                          </select>
                        </div>
                      </div>

                      <div class="field-check uk-width-1-4@m">
                        <label class="uk-form-label uk-visible@m">&nbsp;</label>
                        <span class="uk-form-danger" v-if="dirty && failed"><i class="fas fa-times"></i> <span>{{ errors[0] }}</span> {{i18n["step4-cccountryerror"]}}</span>
                        <span class="uk-form-success uk-visible@m" v-show="passed"><i class="fas fa-check"></i></span>
                      </div>
                    </ValidationProvider>

                    <div class="errorDisplay uk-margin">
                        <div v-show="orderSucceeded === false" class="uk-alert uk-alert-danger uk-margin uk-width-1-1" >
                          <div v-html="i18n['step4-generalerror']"></div>
                        </div>

                        <div v-show="paymentVerified === false" class="uk-alert uk-alert-danger uk-margin uk-width-1-1">
                          <div v-html="i18n['step4-ccvalidationerror']"></div>
                        </div>
                    </div>

                    <div class="uk-flex uk-flex-between uk-margin-top">
                      <button class="uk-button uk-button-secondary" type="button" v-on:click="previousStep"><i class="fas fa-arrow-left"></i> {{["i18n"]["button-previous"]}}</button>
                      <button class="uk-button uk-button-primary" type="submit" :disabled="invalid || checkField !== ''">{{i18n["button-next"]}} <i class="fas fa-arrow-right"></i></button>
                    </div>
                  </form>
                </ValidationObserver>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="sidebar">
        <div v-if="step === 1">
          <div v-html="this['i18n']['trial-left_sidebar']"></div>

          <!-- Don't show custoer logos in trial sidebar
          <div class="uk-text-center uk-margin-top uk-child-width-1-2 uk-child-width-1-4@s uk-grid-small" uk-grid>
            <img class="reference uk-margin" :src="wpParams.template_path + '/assets/img/vue/ownCloud-reference-bahn.svg'" height="28" alt="">
            <img class="reference uk-margin" :src="wpParams.template_path + '/assets/img/vue/ownCloud-reference-fujitsu.svg'" height="28" alt="">
            <img class="reference uk-margin" :src="wpParams.template_path + '/assets/img/vue/ownCloud-reference-lufthansa.svg'" height="28" alt="">
          </div>
          -->
        </div>

        <div v-if="step === 2">
          <div v-html="this['i18n']['trial-left_sidebar_payment']"></div>
        </div>
      </div>
    </div>
    <div class="loading-overlay" :class="{'visible': status === 'saving'}">
        <ocLogo :animated="true"></ocLogo>
    </div>
  </div>
</template>

<script>
import ocLogo from '../components/oc-logo'
import i18nIsoCountries from 'i18n-iso-countries'
import { ValidationProvider, ValidationObserver, validate } from 'vee-validate'
import CardValidator from 'card-validator'
import Vue from 'vue'
import Axios from 'axios'
import qs from 'qs'

export default {
  name: 'Trial',
  components: {
    ocLogo,
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      status: 'idle',
      processing: false,
      // eslint-disable-next-line no-undef
      wpParams: ajax_params,
      checkField: '',
      checkFieldDelay: null,
      thisYear: new Date().getFullYear(),
      logoanimated: false, // logo overlay visible and logo animated
      countries: i18nIsoCountries,
      step: 1,
      duplicateAccount: false,
      paymentVerified: null,
      orderSucceeded: null,
      customer: {
        data: {
          email: '',
          emailRepeat: '',
          firstName: '',
          lastName: '',
          country: ''
        },
        payment: {
          ccard: {
            bearer: 'CreditCard:Stripe',
            cardNumber: '',
            expiryMonth: null,
            expiryYear: null,
            cardHolder: '',
            cvc: '',
            country: ''
          },
          cardType: '' // gets filled on validation
        },
        origin: '',
        termsAccepted: false
      },
      billwerk: {
        providerReturnUrl: i18n['trial-thankyou-page'],
        trialPlanId: process.env.VUE_APP_TRIAL_PLAN,
        apiKey: process.env.VUE_APP_BILLWERK_API_KEY,
        initialized: false,
        signupService: null,
        paymentService: null
      },
      // eslint-disable-next-line no-undef
      i18n: i18n,
      // eslint-disable-next-line no-undef
      JSparams: JSparams,
      recaptchaToken: ''
    }
  },
  methods: {
    async recaptcha () {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "signup".
      this.recaptchaToken = await this.$recaptcha('signup')
    },
    previousStep: function () {
      this.step = this.step - 1
      this.$scrollTo('body')
    },
    toStep: function (nextStep) {
      if (nextStep === 2) {
        this.orderSucceeded = null
        this.paymentVerified = null
      }

      this.step = nextStep
      this.$scrollTo('body')
    },
    signup: function () {
      if (this.processing === true) {
        return false
      }
      this.processing = true

      // start order process
      this.logoanimated = true
      this.status = 'saving'

      this.recaptcha().then(() => {
        Axios.post('',
          qs.stringify({
            action: 'signupworker',
            subaction: 'checkSignup',
            security: window.ajax_params.nonce,
            customer: {
              EmailAddress: this.customer.data.email,
              FirstName: this.customer.data.firstName,
              LastName: this.customer.data.lastName,
              Country: this.customer.data.country
            },
            token: this.recaptchaToken
          })
        )
          .then(response => {
            switch (response.data.success) {
              case 1:
                this.BWcreateOrder()
                break

              case 2:
                this.BWpaymentHandler({})
                break

              case 0:
                this.status = 'idle'
                this.logoanimated = false
                this.processing = false

                switch (response.data.message) {
                  case 'invalid_email':
                    this.$refs.step1.setErrors({
                      email: 'invalid_email'
                    })

                    this.step = 1
                    this.$scrollTo('body')
                    break

                  case 'duplicate_account_trial':
                  case 'duplicate_account_full':
                    this.$refs.step1.setErrors({
                      email: 'duplicate_account'
                    })
                    this.step = 1
                    this.$scrollTo('body')
                    break

                  default:
                    this.status = 'error'
                    break
                }
                break
            }
          }, response => {
            this.showError('billwerkInitFailed')
          })
        return false
      })
    },

    BWinitialize: function () {
      this.billwerk.signupService = new SubscriptionJS.Signup()
      this.billwerk.paymentService = new SubscriptionJS.Payment({
        publicApiKey: this.billwerk.apiKey,
        providerReturnUrl: this.billwerk.providerReturnUrl
      },
      () => {
        this.billwerk.initialized = true
      },
      () => {
        this.showError('billwerkInitFailed')
      })
    },

    BWcreateOrder: function () {
      this.billwerk.signupService.createOrder(this.cartComp, this.customerComp,
        this.BWpay, // Order created. Go on...
        (error) => {
          this.showError('billwerkInitFailed', error) // Order could not be created
        }
      )
    },

    BWpay: function (order) {
      this.billwerk.signupService.paySignupInteractive(
        this.billwerk.paymentService,
        this.customer.payment.ccard,
        order,
        this.BWpaymentHandler, // Everything ok so far. Go on...
        (errorData) => {
          this.showError('paymentFailed', errorData) // Payment failed
        }
      )
    },

    BWpaymentHandler: function (result) {
      this.$cookies.set('e', JSON.stringify({ email: this.customer.data.email, firstName: this.customer.data.firstName }), {
        expires: '30d'
      })

      if (typeof result.Url === 'undefined') { window.location.href = this.billwerk.providerReturnUrl + '?3ds=no' } else { window.location.href = result.Url } // Forward to PSP page to pay
    },

    showError: function (code) {
      this.processing = false
      this.status = 'idle'

      switch (code) {
        case 'billwerkInitFailed': // BillwerkJS could not be initialized
        case 'customerdataUpdateFailed': // Updateing customer data failed
          this.orderSucceeded = false
          break

        case 'paymentFailed':
          // Could not update customers' payment data
          this.paymentVerified = false
          break
      }

      this.$scrollTo('.errorDisplay')
    }
  },
  mounted: function () {
    this.countries.registerLocale(require('i18n-iso-countries/langs/' + this.i18n.language + '.json'))

    if (this.$route.params.email !== undefined && this.$route.params.email !== '') {
      this.customer.data.email = this.$route.params.email
    }

    this.BWinitialize()
  },
  computed: {
    cartComp: function () {
      return {
        planVariantId: this.billwerk.trialPlanId
      }
    },
    customerComp: function () {
      var locale
      if (this.customer.data.country === 'DE' || this.customer.data.country === 'CH' || this.customer.data.country === 'AT') {
        locale = 'de-DE'
      } else {
        locale = 'en-US'
      }

      return {
        'firstName': this.customer.data.firstName,
        'lastName': this.customer.data.lastName,
        'emailAddress': this.customer.data.email,
        'address': {
          'country': this.customer.data.country
        },
        'locale': locale
      }
    },
    ccyears () {
      const year = new Date().getFullYear()
      return Array.from({ length: 10 }, (value, index) => year + index)
    },
    ccmonths () {
      var year = new Date().getFullYear()
      var month = new Date().getMonth()
      if (this.customer.payment.ccard.expiryYear === year) {
        return Array.from({ length: 11 - month }, (value, index) => month + index + 2)
      } else {
        return Array.from({ length: 12 }, (value, index) => 1 + index)
      }
    }
  },
  watch: {
    'customer.payment.ccard.expiryYear': function (after, before) {
      var month = new Date().getMonth()

      if (after === this.thisYear) {
        var validMonths = Array.from({ length: 11 - month }, (value, index) => month + index + 2)
        if (!validMonths.includes(this.customer.payment.ccard.expiryMonth)) {
          this.customer.payment.ccard.expiryMonth = null
        }
      }
    },
    'customer.payment.ccard.cardNumber': function (after, before) {
      // add spaces every 4 characters
      this.customer.payment.ccard.cardNumber = after.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()

      var card = CardValidator.number(this.customer.payment.ccard.cardNumber)

      if (card.card !== null) {
        this.customer.payment.cardType = card.card.niceType
      } else {
        this.customer.payment.cardType = ''
      }
    },
    'customer.data.country': function (after, before) {
      this.customer.payment.ccard.country = after
      Vue.nextTick(() => {
        this.$refs.step2.refs.cccountry.validate()
      })
    },
    'customer.data.email': function (after, before) {
      this.checkField = 'email'
      if (this.checkFieldDelay !== null) {
        clearTimeout(this.checkFieldDelay)
      }

      this.checkFieldDelay = setTimeout(() => {
        this.$store.dispatch('validateEmail', this.customer.data.email)
          .then(() => {
            this.checkField = ''
            validate(this.customer.data.email, 'email').then(result => {
              if (result.valid) {
                this.$refs.step1.setErrors({
                  email: null
                })
              }
            })
          },
          (message) => {
            switch (message) {
              case 'invalid_email':
                this.$refs.step1.setErrors({
                  email: 'invalid_email'
                })
                break

              default:
                this.status = 'error'
                break
            }
            this.checkField = ''
          })
      }, 500)
    }
  }
}
</script>

<style scoped lang="scss">
  @import 'Trial'
</style>
